<script>
import appConfig from "@/app.config";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
  data: () => ({
    assetsPath: appConfig.assetsPath,
  }),
  mounted() {
    // this.gspLoad();
  },
  methods: {
    gspLoad() {
      // *** Animation  ***
      const wHeight = window.innerHeight * 2;
      gsap.registerPlugin(ScrollTrigger);
      gsap.defaults({ duration: 2 });
      const tl = gsap.timeline();

      tl.from(".zoomImage", { scale: 8 }, { scale: 1, ease: "power2.in" }).from(
        "#missionBackground",
        { opacity: 0, y: 50, duration: 0.5 },
        "-=0.9"
      );

      ScrollTrigger.create({
        animation: tl,
        trigger: "#our-animation-section",
        start: "0 77px",
        end: "+=" + wHeight + "",
        scrub: 0.8,
        // markers: true,
        pin: "#sticky",
        //triggerActions: " restart pause reverse pause"
        //stagger: .2 // for childs delay
      });
      ScrollTrigger.refresh();
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 500);
    },
  },
};
</script>
<template>
  <div
    id="our-animation-section"
    :class="$style.ourMissionSection"
    class="d-inline-block"
  >
    <!-- <div class="d-inline-block float-left" id="sticky"> -->
    <div :class="[$style.missionBlock]" ref="missionBlock" id="missionBlock">
      <div :class="$style.webImageBlock" id="webImageBlock">
        <img
          :src="assetsPath + 'images/future-mission@2x.jpg'"
          class="w-100 zoomImage"
          :class="$style.webImage"
          id="webImage"
        />
      </div>
      <div :class="$style.missionBackground" id="missionBackground">
        <div :class="$style.fullBox" ref="fullBox">
          <div :class="$style.missionContent" ref="missonContent">
            <h2 class="heading-2" v-html="$t('ourMission.futureMission')" />
            <p>
              {{ $t("ourMission.missionDesp1") }}
            </p>
            <p>
              {{ $t("ourMission.missionDesp2") }}
            </p>
            <p>
              {{ $t("ourMission.missionDesp3") }}
            </p>
            <div
              :class="$style.aboutBtn"
              class="d-flex justify-content-center align-items-center"
            >
              <button
                @click="GLOBAL.routetrGo('about')"
                type="button"
                class="btn btn-light btn-m"
              >
                {{ $t("ourMission.learnAbout") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";
.ourMissionSection {
  position: relative;
  // overflow: hidden;
  width: 100%;
}
.webImageBlock {
  // background-image: url("#{$assetsPath}images/future-mission@2x.svg");
  // background-size: cover;
  // background-position: center -340px;
  // background-repeat: no-repeat;
  display: flex;
  position: relative;
  width: 100%;
  height: calc(100vh);
  .webImage {
    // position: relative;
    // top: -340px;
    // opacity: 0;
    transform-origin: center 52%;
    // transform: scale(8);
    -o-object-fit: cover;
    object-fit: cover;
  }
}
.missionBlock {
  display: inline-block;
  position: relative;
  // overflow: hidden;
  width: 100%;
  z-index: 111;
  background-color: #14a16f;
  .missionBackground {
    // background-color: #14a16f;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    // background-image: url("#{$assetsPath}images/future-mission@2x.jpg");
    background-position: center bottom;
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 40px;
    display: inline-block;
    margin-top: -12%;
    z-index: 1;
  }

  .missionContent {
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    width: 720px;
    margin: 0 auto;
    max-width: 100%;
    h2 {
      color: $white;
      margin-bottom: 35px;
    }
    p {
      color: $white;
      margin-bottom: 18px;
    }
    .aboutBtn {
      margin-top: 40px;
    }
  }
  .fullBox {
    float: left;
    width: 100%;
  }
}

@media only screen and (max-width: 1440px) {
  .missionBlock {
    .missionBackground {
      margin-top: -16%;
    }
  }
}

@media only screen and (max-width: 992px) {
  .missionBlock {
    .missionBackground {
      margin-top: -23%;
    }
  }
}

@media only screen and (max-width: 767px) {
  .missionBlock {
    .missionContent {
      width: 100%;
      h2 {
        margin-bottom: 30px;
      }
    }
    .missionBackground {
      margin-top: -35%;
      padding: 0 25px;
    }
  }
}
@media only screen and (max-width: 550px) {
  .missionBlock {
    .missionBackground {
      margin-top: -45%;
    }
  }
}

@media only screen and (max-width: 400px) {
  .missionBlock {
    .missionBackground {
      margin-top: -55%;
    }
  }
}
</style>